import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import { Select } from 'carbon-components-react';

var IlSelect = /*#__PURE__*/function (_Component) {
  function IlSelect() {
    _classCallCheck(this, IlSelect);
    return _callSuper(this, IlSelect, arguments);
  }
  _inherits(IlSelect, _Component);
  return _createClass(IlSelect, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(Select, this.props);
    }
  }]);
}(Component);

export { IlSelect };
